import {
  EntryActionLabel,
  findEntryActionLabel,
  listEntryActionLabels
} from '@/common/utils/campaign_entry_action_rule'
import { CampaignEntryActionType, CampaignTargetSnsType, CampaignType } from '@/typings/campaigns'

export type { EntryActionLabel }

const FALLBACK_LABEL = '-'

/**
 * CSV用：改行なし.
 */
export function formatEntryActionType(
  targetSns: CampaignTargetSnsType,
  campaignType: CampaignType,
  entryActionType: CampaignEntryActionType | null
): string {
  if (entryActionType === null) {
    return FALLBACK_LABEL
  }

  return findEntryActionLabel(targetSns, campaignType, entryActionType) ?? FALLBACK_LABEL
}

/**
 * 一覧テーブル用：改行あり(半角括弧の直前に改行を挿入).
 */
export function getEntryActionListLabel(
  targetSns: CampaignTargetSnsType,
  campaignType: CampaignType,
  entryActionType: CampaignEntryActionType | null
): string {
  const label = formatEntryActionType(targetSns, campaignType, entryActionType)
  if (label.includes('(')) {
    return label.replace('(', '\n(')
  }

  return label
}

/**
 * 検索プルダウンの選択肢配列
 */
export function getEntryActionOptions(
  targetSns: CampaignTargetSnsType,
  campaignType: CampaignType
): readonly EntryActionLabel[] {
  return listEntryActionLabels(targetSns, campaignType)
}
